<div class="assets table-container">
    <div class="search-container">
        <div class="row-flex">
            <app-search-input
                placeholder="Search..."
                [inputStr]="currentAssetRuleApiParams.search || ''"
                (inputChanged)="inputChanged($event)"
            ></app-search-input>
            <app-rule-filter
                [companyId]="selectedCompanyId$ | async"
                (ruleIds)="getRuleIds($event)"
                context="rule-filter assets"
            ></app-rule-filter>
            <app-division-filter (divisionIds)="getDivisionIds($event)"></app-division-filter>
        </div>
        <div>
        <div class="row-flex">
            <app-action-button
                class="clear-rule"
                title="Clear Rule"
                [disabled]="!selectedRows.length"
                (buttonClicked)="clearRuleClick()"
            ></app-action-button>

            <app-action-button
                title="Assign Rule"
                [disabled]="!selectedRows.length"
                (buttonClicked)="assignRuleClick()"
            ></app-action-button>
        </div>

        </div>

    </div>


    <div class="header">
        <h2 class="heading-3">Asset List</h2>
        <p>{{ selectedRows?.length }} asset(s) selected.</p>
    </div>

    <ng-container *ngIf="getDataSource().data?.length > 0; else noData" >
        <app-table
            [dataSource]="getDataSource()"
            [view]="view"
            [activeRowId]="clickedRule?.id"
            activeRowIdKey="ruleId"
            [sortActive]="sortActive"
            [sortDirection]="sortDirection"
            (sortChange)="onMatSortChange($event)"
            (selectedRows)="selectedRowsReceived($event)"
            (sortObjChanged)="receiveSortObj($event)"
            (rowClicked)="onRowClick($event)"
            checkboxText="SELECT ASSETS"
        >
            <app-column
                name="Asset Name"
                id="assetName"
                sortable="true"
                data="assetName"
                view="assets"
            >
            </app-column>
            <app-column
                name="Division Name"
                id="divisionName"
                sortable="true"
                data="divisionName"
                view="assets"
            >
            </app-column>
            <app-column
                name="Rule Name"
                id="ruleName"
                sortable="true"
                data="ruleName"
                view="assets"
            >
            </app-column>

        </app-table>

        <app-paginator
            [length]="paginatorLength"
            [page]="currentAssetRuleApiParams.page || '1'"
            [pageSizeOptions]="pageSizeOptions"
            (pageQueryChange)="pageQueryChange($event)"
        ></app-paginator>
    </ng-container>

    <ng-template #noData>
        <p *ngIf="!error">There are 0 assets.</p>
    </ng-template>


    <p *ngIf="error">An error occurred fetcthing the data.</p>

 </div>


 <ng-template #assetRuleErrors>
    <p class="evir-font-default">{{ errorMessage }}</p>
</ng-template>





